<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Edit Room Raccoon mapping</h5>
                <a class="close hover" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </a>
            </div>
            <div class="modal-body">
                <div *ngIf="ratePlan">

                    <h3 class="mat-title mb-1">{{ratePlan.name}} room selection</h3>

                    <p class="mb-1">Select the rooms this rate should be mapped to in Room Raccoon</p>

                    <p class="mb-2">Room Raccoon will intermittently poll the data to sync this rate to the rooms selected</p>

                    <p class="mb-1" style="font-style: italic; font-size: 12px;">Please not syncing may take several hours</p>

                    <div class="mb-4 mt-3">

                        <button
                            class="mr-2 mb-2"
                            *ngFor="let room of rooms"
                            mat-raised-button
                            [color]="isRoomSelected(room.id) > -1 ? 'primary' : 'grey'"
                            color="primary"
                            (click)="toggleRoom(room.id)">
                            {{room.name}}
                        </button>

                    </div>


                    <div class="text-right mb-4">
                        <button mat-raised-button color="primary" (click)="save()">Save</button>
                        <div class="text-danger mt-2" *ngIf="errorString">{{errorString}}</div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade show modal-slide-show"></div>
